module.exports = ".modal-content {\r\n  overflow: unset;\r\n}\r\n"